import { Container, Typography, Divider, Button } from "@mui/material"
import * as Sentry from "@sentry/react"
import { useContext } from "react"
import { useNavigate } from "react-router-dom"
import UserContext from "../../context/UserContext"
import useFetch from "../../hooks/useFetch"
import { F_INDEX } from "../../constants/routes"

const isWithinLast24Hours = (date) => {
  const dateTime = new Date(date).getTime()
  const now = Date.now()

  return now - dateTime <= 24 * 60 * 60 * 1000 && dateTime <= now
}

const Metrics = () => {
  const { data, loading } = useFetch("/metrics")
  const { setUserDataExternal } = useContext(UserContext)
  const navigate = useNavigate()

  const handleLogout = () => {
    Sentry.setUser(null)
    Sentry.setTags({})
    setUserDataExternal(null)
    localStorage.clear()
    navigate(F_INDEX)
  }

  return loading ? (
    <Container maxWidth="md" sx={{ p: 2 }}>
      <Typography variant="h6">Loading...</Typography>
      <Button variant="contained" onClick={handleLogout} sx={{ mt: 2 }}>
        Logout
      </Button>
    </Container>
  ) : (
    <Container maxWidth="md" sx={{ p: 2 }}>
      <Typography variant="h5" gutterBottom>
        Metrics
      </Typography>

      <Typography variant="h6" gutterBottom>
        Users
      </Typography>

      <Typography variant="body1">Total: {data?.users?.length}</Typography>
      <Typography variant="body1">Verified: {data?.users?.filter((u) => u.verified)?.length}</Typography>
      <Typography variant="body1">Last 24 h: {data?.users?.filter((u) => isWithinLast24Hours(u.registeredTimestamp))?.length}</Typography>
      <Typography variant="body1">
        Last 24 h and verified: {data?.users?.filter((u) => isWithinLast24Hours(u.registeredTimestamp) && u.verified)?.length}
      </Typography>

      <Divider />

      <Typography variant="h6" gutterBottom>
        Ledger
      </Typography>

      <Typography variant="body1">Total: {data?.ledgers?.length}</Typography>
      <Typography variant="body1">Total Buy: {data?.ledgers?.filter((x) => x.action === "buy")?.length}</Typography>
      <Typography variant="body1">Total Sell: {data?.ledgers?.filter((x) => x.action === "sell")?.length}</Typography>
      <Typography variant="body1">Last 24 h: {data?.ledgers?.filter((x) => isWithinLast24Hours(x.timestamp))?.length}</Typography>
      <Typography variant="body1">
        Last 24 h Search: {data?.ledgers?.filter((x) => x.status === "search" && isWithinLast24Hours(x.timestamp))?.length}
      </Typography>
      <Typography variant="body1">
        Last 24 h Matched: {data?.ledgers?.filter((x) => x.status === "matched" && isWithinLast24Hours(x.timestamp))?.length}
      </Typography>
      <Typography variant="body1">Search: {data?.ledgers?.filter((x) => x.status === "search")?.length}</Typography>
      <Typography variant="body1">Matched: {data?.ledgers?.filter((x) => x.status === "matched")?.length}</Typography>
      <Typography variant="body1">Finished: {data?.ledgers?.filter((x) => x.status === "finished")?.length}</Typography>
      <Typography variant="body1">Cancelled: {data?.ledgers?.filter((x) => x.status === "cancelled")?.length}</Typography>

      <Button variant="contained" onClick={handleLogout} sx={{ mt: 2 }}>
        Logout
      </Button>
    </Container>
  )
}

export default Metrics
